import * as H from "history";
import { ScrollBar } from "./scrollbar";

export function convertPathToObject(path: string, params: any[]) {
    if (!path.endsWith('/')) path = path + '/';
    const reg = /\:.*?\//g;
    const tokens = [];
    while (true) {
        const m = reg.exec(path);
        if (!m) break;
        tokens.push(m[0].substr(1, m[0].length - 2));
    }
    if (!params) params = [];
    const o = tokens.reduce((pv, cv, index) => {
        //@ts-ignore
        pv[cv] = params.length > index ? params[index] : null;
        return pv;
    }, {});
    return o;
}
export function showScrollbar(callback?: (scrollbarWidth: number) => void) {
    const scrollbarWidth = ScrollBar.getScrollbarWidth();
    if (scrollbarWidth > 0) {
        document.body.classList.remove("scrollbar-hider");
        document.body.style.marginRight = ``;
        if (callback) callback(scrollbarWidth);
    }
}
export function hideScrollbar(callback?: (scrollbarWidth: number) => void) {
    const scrollbarWidth = ScrollBar.getScrollbarWidth();
    if (scrollbarWidth > 0) {
        document.body.classList.add("scrollbar-hider");
        document.body.style.marginRight = `${scrollbarWidth}px`;
        if (callback) callback(scrollbarWidth);
    }
}
/*
export function showDialog2(Content: any) {
    return new Promise((resolve, reject) => {
        let el = document.createElement('div');
        document.getElementById('modal-root')!.appendChild(el);
        let ok = (returnValue: number) => {
            ReactDOM.unmountComponentAtNode(el);
            document.getElementById('modal-root')!.removeChild(el);
            resolve(returnValue);
        };
        // ReactDOM.render(
        //     <CSSTransition timeout={1000} classNames="fade" in={true} mountOnEnter={true}>
        //         <Content ok={ok} />
        //     </CSSTransition>,
        //     el);
        // let dom = (
        //     <TransitionGroup component="div">
        //         <FadeAndSlideTransition duration={300}>
        //             <Content ok={ok} />
        //         </FadeAndSlideTransition>
        //     </TransitionGroup>);
        // ReactDOM.render(dom, el);
        // ReactDOM.render(<Content ok={ok} />, el);
    });
}
    */
function parseUrl(history: H.History<any>) {
    const path = history.location.pathname
    let qs = history.location.search;
    if (qs.startsWith("?")) qs = qs.slice(1);
    // tslint:disable-next-line:prefer-const
    // const [path, qs] = hash.split("?");
    // if (path.startsWith("#/")) path = path.replace("#/", "/");
    const map = {} as { [key: string]: string };
    if (!qs) return { path, query: map };
    const query = qs.split("&").reduce((soFar, nv) => {
        const [name, value] = nv.split("=");
        soFar[name] = value;
        return soFar;
    }, map)
    return { path, query };
}
export function removeQueryString(history: H.History<any>, name2: string): string {
    const { path, query } = parseUrl(history);
    delete query[name2];
    const s = Object.keys(query).reduce((soFar, key) => {
        if (!soFar) return `${key}=${query[key]}`;
        return `${soFar}&${key}=${query[key]}`;
    }, "");
    if (s) return `${path}?${s}`;
    return path;
}
export function addQueryString(history: H.History<any>, name2: string, value2: any): string {
    const { path, query } = parseUrl(history);
    query[name2] = `${value2}`;
    const s = Object.keys(query).reduce((soFar, key) => {
        if (!soFar) return `${key}=${query[key]}`;
        return `${soFar}&${key}=${query[key]}`;
    }, "");
    if (s) return `${path}?${s}`;
    return path;
}
